import type { FC } from "react";

import { EditCampaignProvider } from "../context/EditCampaignContext";
import { CampaignProvider } from "../context/CampaignContext";
import { Outlet } from "react-router-dom";

interface CampaignContextWrapperProps {}

export const CampaignContextWrapper: FC<CampaignContextWrapperProps> = () => {
  return (
    <EditCampaignProvider>
      <CampaignProvider>
        <Outlet />
      </CampaignProvider>
    </EditCampaignProvider>
  );
};
